import PropTypes from 'prop-types';
import React, { useRef, useEffect, useState, useReducer} from 'react';
import classNames from 'classnames';
import Leaflet from 'leaflet';
import keys from 'lodash/keys';
import config from '../../config';

import {MapContext, boundedElementsReducer} from './MapContext';

const OpenMap = ({className, children, centerCoords = config.get('defaultMapCenter')}) => {
    const classes = classNames(className);
    const mapRef = useRef(null);
    const [map, setMap] = useState(null);
    const [boundedElements, boundedElementsDispatch] = useReducer(boundedElementsReducer, {});

    //Setting up the map
    useEffect(() => {
        if (mapRef.current !== null && map === null) {
            const mapInstance = new Leaflet.Map(mapRef.current);
            mapInstance.setView(centerCoords, 13);
            mapInstance.zoomControl.setPosition('bottomright');
            Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            }).addTo(mapInstance);
            setMap(mapInstance);
        }
    }, [mapRef, map, centerCoords]);

    useEffect(() => {
        const bounds = keys(boundedElements).reduce((array, key) => {
            array.push(boundedElements[key]);
            return array;
        }, []);
        if (bounds.length > 0) {
            map.fitBounds(bounds, {padding: [50, 50]});
        }
    }, [boundedElements, map]);

    return (<div className={classes}>
        <div style={{ width: '100%', height: '100%'}} ref={mapRef}>
            <MapContext.Provider value={{map, boundedElementsDispatch}}>
                {children}
            </MapContext.Provider>
        </div>
    </div>);
};

OpenMap.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    centerCoords: PropTypes.objectOf({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired
    })
};

export default OpenMap;



// WEBPACK FOOTER //
// ./src/components/openMap/index.js